"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNew = exports.isIncomplete = exports.isFailed = exports.isCompleted = exports.withPersonaScriptSrc = exports.personaInquiryStatus = void 0;

var _constants = require("../tasks/constants");

var personaInquiryStatus = {
  CREATED: 'created',
  PENDING: 'pending',
  COMPLETED: 'completed',
  FAILED: 'failed',
  EXPIRED: 'expired',
  // decisioning flow
  APPROVED: 'approved',
  DECLINED: 'declined'
};
exports.personaInquiryStatus = personaInquiryStatus;
var withPersonaScriptSrc = 'https://cdn.withpersona.com/dist/persona-v3.5.0.js';
exports.withPersonaScriptSrc = withPersonaScriptSrc;

var isCompleted = function isCompleted(_ref) {
  var task = _ref.task,
      personaStatus = _ref.personaStatus,
      personaInquiryId = _ref.personaInquiryId;
  return (task === null || task === void 0 ? void 0 : task.status) === _constants.taskStatus.COMPLETED || personaInquiryId && [personaInquiryStatus.COMPLETED, personaInquiryStatus.APPROVED].includes(personaStatus);
};

exports.isCompleted = isCompleted;

var isFailed = function isFailed(_ref2) {
  var task = _ref2.task,
      personaStatus = _ref2.personaStatus,
      personaInquiryId = _ref2.personaInquiryId;
  return (task === null || task === void 0 ? void 0 : task.status) !== _constants.taskStatus.COMPLETED && personaInquiryId && [personaInquiryStatus.FAILED, personaInquiryStatus.DECLINED].includes(personaStatus);
};

exports.isFailed = isFailed;

var isIncomplete = function isIncomplete(_ref3) {
  var task = _ref3.task,
      personaStatus = _ref3.personaStatus,
      personaInquiryId = _ref3.personaInquiryId;
  return (task === null || task === void 0 ? void 0 : task.status) !== _constants.taskStatus.COMPLETED && personaInquiryId && [personaInquiryStatus.CREATED, personaInquiryStatus.PENDING].includes(personaStatus);
};

exports.isIncomplete = isIncomplete;

var isNew = function isNew(_ref4) {
  var task = _ref4.task,
      personaStatus = _ref4.personaStatus,
      personaInquiryId = _ref4.personaInquiryId;
  return (task === null || task === void 0 ? void 0 : task.status) !== _constants.taskStatus.COMPLETED && (!personaInquiryId || personaStatus === personaInquiryStatus.EXPIRED);
};

exports.isNew = isNew;